import {Component, Input, OnInit} from '@angular/core';
import {ColDef, ColumnApi, GridApi, GridReadyEvent} from 'ag-grid-community';
import {DispoDetails} from '../../models/dispoDetailsModel';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';
import {AG_GRID_LOCALE_DE} from '../../locale.de';

@Component({
  selector: 'lib-dispo-details',
  templateUrl: './dispo-details.component.html',
  styleUrls: ['./dispo-details.component.css']
})
export class DispoDetailsComponent implements OnInit {

  public gridApi: GridApi;
  public gridColumnApi: ColumnApi;
  public columnDef: ColDef[];
  public defaultColDef: ColDef;

  public carretUp = faCaretUp;
  public carretDown = faCaretDown;
  public show: boolean;

  public isCollapsed: boolean = false;

  public locale = AG_GRID_LOCALE_DE;

  @Input() dispoDetails: DispoDetails[]; 


  constructor() {
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      flex: 1,
      lockPosition: true, cellClass: 'locked-col'
    };

    this.columnDef = [
      {
        field: 'tournr',
        valueGetter: this.editedTourNr,
      },
      {
        field: 'tourSektor',
        headerName: 'Toursektor',
      },
      {
        field: 'stopp',
        headerName: 'Soll-Stopp',
      },
      {
        field: 'ausliefertag',
        headerName: 'Datum',
        sort: 'desc'
      },
      {
        field: 'gewicht',
        headerName: 'Kg',
      }
    ]
  }

  ngOnInit(): void {
  }

  gridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.dispoDetails)
  }

  editedTourNr(param: any) {
    let tournr = param.data.tournr;
    return tournr ? tournr.slice(0, 1) + '-' + tournr.slice(1) : '';
  }
}
